module.exports = __webpack_public_path__ + "static/media/crecimiento_lines.a0dd6f91.png";